<div class="wrapper">
  <h2>
    Профиль модели {{ _model?.manufacturer?.description }}
    {{ _model?.description }}
  </h2>
  <form [formGroup]="profileForm" (ngSubmit)="save()" class="drop-padding">
    <mat-form-field appearance="outline">
      <mat-label>Наименование</mat-label>
      <input matInput type="text" formControlName="description" />
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Начало производства</mat-label>
      <input matInput [matDatepicker]="picker_from" formControlName="manufacture_date_from" />
      <mat-datepicker-toggle matSuffix [for]="picker_from"></mat-datepicker-toggle>
      <mat-datepicker #picker_from></mat-datepicker>
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Конец производства</mat-label>
      <input matInput [matDatepicker]="picker_to" formControlName="manufacture_date_to" />
      <mat-datepicker-toggle matSuffix [for]="picker_to"></mat-datepicker-toggle>
      <mat-datepicker #picker_to></mat-datepicker>
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Кузов</mat-label>
      <input matInput type="text" formControlName="body" />
    </mat-form-field>
    <button mat-flat-button color="primary" type="submit">Сохранить</button>
    <button mat-flat-button color="warn" type="button" (click)="openConfirmDialog()">
      Удалить
    </button>
  </form>
</div>
